export default {


    /**
     * 修改进货记录商品数据类型（网络数据/本地数据）
     * @param type 数据来源类型 true-本地数据 false-网络数据
     * 
     */
    SetPurchDataType(type) {
        localStorage.setItem('purch_goods_type',type);
    },

    /**
     * 获取进货记录商品数据信息（网络数据/本地数据）
     * @return 数据来源类型 true-本地数据 false-网络数据
     */
    GetPurchDataType() {
        var result=localStorage.getItem('purch_goods_type');
        return result=='true' ? true : false;
    },

    /**
     * 保存数据到当前浏览器
     * @param title string 保存数据名称
     * @param list [] 保存数据类型
    */
   SetBrowData(title,list) {
        if(!title || title=='' || title=='null') return '';  //没有标题名称时不能保存
        !list || list=='' || list=='null' ? list=[] : '';     //数据为空时直接返回空数组

        list=JSON.stringify(list);
        localStorage.setItem(title,list);
   },

   /**
    * 获取已保存到浏览器的数据
    * @param title string 获取数据类型名称
   */
  GetBrowData(title) {
      if(!title || title=='' || title=='null') return [];
      var list=localStorage.getItem(title);
      if(!list || list=='' || list==null || list=='null') return [];

      list=JSON.parse(list);
      return list;
  },



    /**
     * 保存商品下载的商品信息到本地
     * @param goodslist array 商品信息列表
    */
    SetGoods(goodslist) {

        //数据为空时，直接返回不操作
        if(goodslist.length==0) return false;
         
        //提取当前已下载的商品信息
        var goodsids=localStorage.getItem('goods_ids');
        goodsids && goodsids!='' && goodsids!='null' ? goodsids=JSON.parse(goodsids) : goodsids=[];
        
        var nums=-1;
        var goodsid='';
        for(var i in goodslist) {
            nums=-1;
            goodsid=goodslist[i].id;
            nums=goodsids.indexOf(goodsid);
            nums==-1 ? goodsids.push(goodsid) : '';
            localStorage.setItem('goods_data_'+goodsid,JSON.stringify(goodslist[i]));  //保存商品信息到本地信息库
        }
        localStorage.setItem('goods_ids',JSON.stringify(goodsids)); //更新商品目录信息表
    },

    /**
     * 清除本地商品信息
    */
    ClearGoods() {
        var goodsids=localStorage.getItem('goods_ids');
        goodsids && goodsids!='' && goodsids!='null' ? goodsids=JSON.parse(goodsids) : goodsids=[];
        if(goodsids.length==0) return false;

        var goodsid='';
        for(var i in goodsids) {
            goodsid=goodsids[i];
            localStorage.setItem('goods_data_'+goodsid,null);
        }
        localStorage.setItem('goods_ids',null);
    },

    /**
     * 获取保存到本地的商品信息
    */
   GetGoods() {

        //获取本地商品信息目录
        var goodsids=localStorage.getItem('goods_ids');
        goodsids && goodsids!='' && goodsids!='null' ? goodsids=JSON.parse(goodsids) : goodsids=[];
        if(goodsids.length==0) return [];
        
        //解析并提取本地商品数据
        var goodslist=[];
        var goodsinfo={};
        var goodsid='';
        for(var i in goodsids) {
            goodsid=goodsids[i];
            goodsinfo=localStorage.getItem('goods_data_'+goodsid);
            if(goodsinfo && goodsinfo!='' && goodsinfo!=='null') {
                goodsinfo=JSON.parse(goodsinfo);
                goodslist.push(goodsinfo);
            }
        }
        return goodslist;
   },
   
   /**
    * 本地商品信息搜索
    * @param brandid int 品牌id
    * @param key string 关键字
    * @param mode string 数据搜索模式  list-列表模式  key-关键字模式
    * @param p int 页数
    * @param rollpage int 每页条数
   */
   GoodsSearch(param) {
        var goodslist=this.GetGoods();                                   //获取商品信息
        if(goodslist.length==0) return {rows:0,list:[]};                 //数据为空时直接返回空
        var brandid=param && param.brandid > 0 ? param.brandid : 0;      //品牌信息
        var key=param && param.key && param.key!='' ? param.key : '';                 //关键字
        var mode=param && param.mode!='' ? param.mode : 'list';          //默认为列表模式
        var p=param && param.p!='' ? param.p : 1;                        //页数
        var rollpage=param && param.rollpage!='' ? param.rollpage : 10;  //每页条数
        if(mode=='key' && key=='') return {rows:0,list:[]};              //关键字搜索模式下无关键字时直接返回空数组

        var resultgoods=[]; //搜索结果集
        var goodsinfo={};   //单个商品
        var goodsname='';
        for(var i=0;i < goodslist.length;i++) {
            goodsinfo=goodslist[i];
            goodsname=goodsinfo.showname+'_'+goodsinfo.pnumber;
            if(brandid > 0 && brandid!=goodsinfo.brand_id) continue;     //品牌id搜索过滤
            if(key!='' && goodsname.indexOf(key)==-1) continue; //关键字搜索过滤 
            resultgoods.push(goodsinfo);
        }

        var rows=resultgoods.length;
        var spage=(p-1)*rollpage;
        var epage=p*rollpage-1;
        var list=[];
        for(var i=0;i < resultgoods.length;i++) {
            if(i >= spage && i <= epage) list.push(resultgoods[i]);
        }

        return {rows:rows,list:list};
   },



}